import React, { memo } from 'react';
import { TimesCircleIcon } from '../../assets/icons/TimesCircleIcon';
import { useMergedClassNames } from '../../utils/HTMLutils';
import './Chip.scss';
const rootClassName = 'component-chip';

type ChipTheme = 'primary' | 'primary-outline' | 'danger';

export interface ChipProps {
  label?: string;
  w100?: boolean;
  allClickable?: boolean;
  onClick: () => void;
  disabled?: boolean;
  theme?: ChipTheme;
}

function Chip(props: ChipProps) {
  return (
    <div
      className={useMergedClassNames([
        rootClassName,
        props.w100 ? 'w100' : '',
        props.allClickable ? 'all-clickable' : '',
        props.theme ?? 'primary-outline',
      ])}
      onClick={() => {
        if (
          !props.disabled &&
          props.allClickable &&
          typeof props.onClick === 'function'
        ) {
          props.onClick();
        }
      }}
    >
      <span className='nunito'>{props.label}</span>
      <div
        className={`${rootClassName}-button`}
        onClick={() => {
          if (!props.disabled && typeof props.onClick === 'function') {
            props.onClick();
          }
        }}
      >
        <TimesCircleIcon />
      </div>
    </div>
  );
}

export default memo(Chip);
